'use client';
import heroStyles from '@/components/public/public-hero.module.css';
import Image from 'next/image';
import { useState } from 'react';
export function PodcastPageHeroImage({ src, alt }: { src: string; alt: string }) {
  const [failed, setFailed] = useState(false);
  return <div className={heroStyles.backdrop} data-scenery-hero>
    {src && !failed && <Image unoptimized priority fill sizes="100vw" src={src} alt={alt} className="object-cover object-center" onError={() => setFailed(true)} />}
    {(!src || failed) && <div className="absolute inset-0 bg-[linear-gradient(115deg,#fbf8f3,#e2e9dc)]" />}
    <div className={heroStyles.overlay} />
  </div>;
}
